import { TOOLS } from "./chartConfig"
import { pickTarget } from "redux/ducks/Chart"
import _ from "lodash"

export const TENKAN_MARGIN = {
  DEFAULT: 32,
  SHOW: 64,
}

// ルーペ用フラグ。ルーペを設定しなおすことで、オンオフを切り替えているため他のツールをオンにした時に、リセットされてしまう。1度オンにしたかどうかを判定するため用の変数。
let active = false

export const setTools = (tools: any, plotType: string, _controller: any) => {
  if (!_controller || !_controller.Chart) return
  const _setKVOnOff = setKVOnOff(_controller)
  _setKVOnOff("useCrossCursor", !!_.find(tools, _.pick(TOOLS[0], pickTarget)))
  _setKVOnOff("useReadValue", !!_.find(tools, _.pick(TOOLS[8], pickTarget)))
  _setKVOnOff(
    "usePrevDayClosingLine",
    !!_.find(tools, _.pick(TOOLS[2], pickTarget))
  )
  _setKVOnOff("useCurPrice", !!_.find(tools, _.pick(TOOLS[3], pickTarget)))
  _setKVOnOff(
    "useMado",
    plotType === "candle"
      ? !!_.find(tools, _.pick(TOOLS[7], pickTarget))
      : false
  )

  // 転換点表示時は、ロウソク上下幅を倍に取るようにする
  _controller.Chart.SetEnvYMinMaxHeightMargin(
    !!_.find(tools, TOOLS[1]) ? TENKAN_MARGIN.SHOW : TENKAN_MARGIN.DEFAULT
  )
  _controller.Chart.set_UseTenkan(!!_.find(tools, _.pick(TOOLS[1], pickTarget)))
  _controller.Chart.SetEnvYMinMaxHeightMargin(
    !!_.find(tools, _.pick(TOOLS[1], pickTarget))
      ? TENKAN_MARGIN.SHOW
      : TENKAN_MARGIN.DEFAULT
  )
  // 転換点表示設定の時だけリセットしないと、内部でエラーが起こるようだ
  // リセットして転換点計算
  // if (!!_.find(tools, TOOLS[1]) && _tProc)
  //   // EDGEだと、少し時間おかないと、「resetDEvtProc:failed to find ProcDHandler by sNode」が発生してしまう
  //   setTimeout(() => {
  //     _controller.Chart.get_Chart().ResetDEvtProc(_tProc)
  //   }, 1500)
  // 日柄分析
  _setKVOnOff("CycleAnalysis", !!_.find(tools, _.pick(TOOLS[6], pickTarget)))
  // 価格帯別出来高
  _setKVOnOff("PriceVolume", !!_.find(tools, _.pick(TOOLS[5], pickTarget)))

  // ルーペ
  if (!!_.find(tools, _.pick(TOOLS[4], pickTarget)) && !active) {
    active = true
    _controller.Chart.get_LoupeViewX()
  }
  if (!_.find(tools, _.pick(TOOLS[4], pickTarget)) && active) {
    active = false
    _controller.Chart.SetViewOpNone()
  }
}

export const setKVOnOff = (_controller: any): Function => {
  if (!_controller || !_controller.Chart) return
  return (key: string, flag: boolean): void => {
    _controller.Chart.SetKV(key, flag)
    _controller.Chart.ApplyViewProp()
    _controller.Chart.Draw()
  }
}
